import { render } from "./ProductPickerQuickViewGallery.vue?vue&type=template&id=2081001d"
import script from "./ProductPickerQuickViewGallery.vue?vue&type=script&lang=js"
export * from "./ProductPickerQuickViewGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__